export const content = {
    breadcrumbs:[
        {id:1, label:'Restaurar contraseña', url:'/account/reset/:id/:idtoken', selected:true}
    ]
}